import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { ExecutionResult } from 'graphql';
import { MutationResult } from '@apollo/react-common';
import {
  BidOnAuctionLotInput,
  BidOnAuctionLotMutation,
  BidOnAuctionLotMutationVariables,
  AuctionLot,
  UseBidOnAuctionQueryVariables,
  UseBidOnAuctionQuery,
} from '../../types/__generated__';
import { DataProxy } from 'apollo-cache';
import UseBidOnAuction from './useBidOnAuction.gql';

export const BID = gql`
  mutation BidOnAuctionLot($input: BidOnAuctionLotInput!) {
    bidOnAuctionLot(input: $input) {
      successful
      lotId
      highestBid {
        value
        currencyCode
      }
    }
  }
`;

export default function useBidOnAuctionLot(): [
  (
    bid: BidOnAuctionLotInput,
  ) => Promise<ExecutionResult<BidOnAuctionLotMutation>>,
  MutationResult<BidOnAuctionLotMutation>,
] {
  const [runMutation, mutationResult] = useMutation<
    BidOnAuctionLotMutation,
    BidOnAuctionLotMutationVariables
  >(BID, {
    update(cache, { data }) {
      if (!data || !data.bidOnAuctionLot) {
        return;
      }

      // console.log('update - data');
      // console.log(data);

      const pageSlug = '12345';

      const result = readLots(pageSlug, cache);

      const previousLots = result.previousLots as AuctionLot[];

      const index = previousLots?.findIndex(lot => {
        return lot.legacyId === data.bidOnAuctionLot?.lotId;
      });

      if (index < 0) {
        return;
      }

      const updatedLot = {
        ...previousLots[index],
        highestBid: data.bidOnAuctionLot.highestBid,
      };

      let newLots = JSON.parse(JSON.stringify(previousLots));
      newLots.splice(index, 1, updatedLot);

      const newData: UseBidOnAuctionQuery = { getAuctionLots: newLots };

      writeLots(pageSlug, newData, cache);
    },
    context: {
      credentials: 'include',
    },
  });

  const placeBid = (bid: BidOnAuctionLotInput) => {
    return runMutation({
      variables: {
        input: bid,
      },
    });
  };

  return [placeBid, mutationResult];
}

const readLots = (pageSlug: string, cache: DataProxy) => {
  const result = cache.readQuery<
    UseBidOnAuctionQuery,
    UseBidOnAuctionQueryVariables
  >({
    query: UseBidOnAuction,
    variables: {
      slug: pageSlug,
    },
  });

  const previousLots = result?.getAuctionLots;

  // console.log('readLots - result');
  // console.log(result);

  return { previousLots };
};

const writeLots = (
  pageSlug: string,
  data: UseBidOnAuctionQuery,
  cache: DataProxy,
): void => {
  // console.log('writeLots - data');
  // console.log(data);

  cache.writeQuery<UseBidOnAuctionQuery, UseBidOnAuctionQueryVariables>({
    query: UseBidOnAuction,
    data,
    variables: {
      slug: pageSlug,
    },
  });
};
